import wuliusudi from '@/assets/images/img/wuliusudi.png'
import qizhi from '@/assets/images/img/qizhi.png'
import qizhiActive from '@/assets/images/img/qizhi_active.png'

import wujiaoxing from '@/assets/images/img/wujiaoxing.png'
import wuliusudiAtive from '@/assets/images/img/wuliusudi_active.png'
import guijidian from '@/assets/images/img/guijidian.png'
import guijidianActive from '@/assets/images/img/guijidian_active.png'

// // 轨迹点
// const traceMarker = {
//   // 轨迹点
//   // url: 'https://a.amap.com/jsapi_demos/static/images/mass2.png',
//   url: guijidian,
//   anchor: new AMap.Pixel(6, 6),
//   size: new AMap.Size(12, 12)
// }
// // 轨迹点激活状态
// const traceMarkerActive = {
//   // url: 'https://a.amap.com/jsapi_demos/static/images/mass1.png',
//   url: guijidianActive,
//   anchor: new AMap.Pixel(6, 6),
//   size: new AMap.Size(12, 12)
// }
//
// // 轨迹点开始
// const traceStart = {
//   url: wuliusudi,
//   anchor: new AMap.Pixel(10, 10),
//   size: new AMap.Size(20, 20)
// }
//
// // 轨迹点开始激活状态
// const traceStartActive = {
//   url: wuliusudiAtive,
//   anchor: traceStart.anchor,
//   size: traceStart.size
// }
// // 轨迹点结束
// const traceEnd = {
//   url: qizhi,
//   anchor: new AMap.Pixel(10, 10),
//   size: new AMap.Size(20, 20)
// }
// // 到达点
// const traceReach = {
//   url: wujiaoxing,
//   anchor: new AMap.Pixel(10, 15),
//   size: new AMap.Size(20, 20)
// }

// 地图上的图标
// 车辆绿色图标
export const marker_car =
  "<div><i class='iconfont icon-wuliusudi' style='font-size:30px;'></i></div>"
export const marker_car_red =
  "<div><i class='iconfont icon-wuliusudi' style='font-size:30px;color: red; '></i></div>"

// 车辆激活时的图标
export const marker_car_active =
  "<div><i class='iconfont icon-wuliusudi color-orange' style='font-size:30px;'></i></div></i>"

// 架构图标
export const marker_arch =
  "<div><i class='iconfont icon-zhuzhaiqu' style='font-size:30px;'></i></div>"

// 架构被激活时的图标
export const marker_arch_active =
  "<div><i class='iconfont icon-zhuzhaiqu color-orange' style='font-size:30px;'></i></div></i>"

// 架构监测点异常时的图标
export const marker_arch_error =
    "<div><i class='iconfont icon-zhuzhaiqu color-red' style='font-size:30px;'></i></div></i>"

// 定位图标
export const marker_location =
  "<i class='el-icon-location color-theme font-24'></i>"

// 定位图标
export const marker_location_red =
  "<i class='el-icon-location font-24' style='color: red;'></i>"

// 定位图标
export const marker_location_yellow =
  "<i class='el-icon-location   font-24' style='color: yellow;'></i>"
// 定位图标
export const marker_location_orange =
  "<i class='el-icon-location   font-24' style='color: orange;'></i>"

// 定位图标
export const marker_location_dark_red =
  "<i class='el-icon-location font-24' style='color: #6c0812'></i>"
// 定位图标
export const marker_location_cyan =
  "<i class='el-icon-location font-24' style='color: cyan'></i>"

// 定位图标
export const marker_arch_position =
  "<i class='el-icon-location ' style='font-size:30px;'></i>"


// 位置图标
export const marker_position =
  "<i class='iconfont icon-yuandian color-theme' style='font-size: 60px'></i>"

// 位置图标
export const marker_position_red =
  "<i class='iconfont icon-yuandian-red '  style='font-size: 60px'></i>"
// 位置图标
export const marker_position_yellow =
  "<i class='iconfont icon-yuandian-yellow color-theme' style='font-size: 60px'></i>"

export const marker_arrival_point = "<i class='icon iconfont icon-map-thumbtack-full ' style='font-size: 30px' ></i>"

// 到达点
export const marker_arrival_point_progress = "<i class='icon iconfont icon-map-thumbtack-full ' style='font-size: 30px;color: orange' ></i>"

export const marker_arrival_point_start = "<i class='icon iconfont icon-map-thumbtack-full  ' style='font-size: 30px;color: green' ></i>"

export const marker_arrival_point_end = "<i class='icon iconfont icon-map-thumbtack-full ' style='font-size: 30px;color: red' ></i>"

// 地图架构图标
export const marker_scene_map =
  "<div><i class='icon-wuliuzhongxin' style='font-size:30px;'></i></div>"

// 地图架构图标
export const marker_trace_asset =
  "<div><i class='icon-a-11-xianghuozhuizong' style='font-size:30px;'></i></div>"




// 海量点的点样式
// export const massStyle = [
//   {
//     url: 'https://a.amap.com/jsapi_demos/static/images/mass0.png',
//     anchor: new AMap.Pixel(6, 6),
//     size: new AMap.Size(11, 11)
//   },
//   traceMarkerActive,
//   traceMarker,
//   // 起点
//   traceStart,
//   // 终点
//   traceEnd,
//   // 到达点
//   traceReach
// ]

/**
 * 创建海量点
 * @param {Array} massPoint 例 [{"lnglat":[116.258446,37.686622],"name":$t('integration.jingxian_county'),"style":2}]
 */
export const massMarkers = function (massPoint) {
  return null;
}
// export const trace_marker_active = new AMap.Marker({
//   icon: new AMap.Icon({
//     image: traceMarkerActive.url,
//     imageSize: traceMarker.size
//   }),
//   offset: new AMap.Pixel(-5, -5)
// })

// export const trace_start_active = new AMap.Marker({
//   icon: new AMap.Icon({
//     image: traceStartActive.url,
//     imageSize: traceStart.size,
//     imageOffset: new AMap.Pixel(-2, 20)
//   }),
//   zIndex: 999
// })
// export const trace_end_active = new AMap.Marker({
//   icon: new AMap.Icon({
//     image: qizhiActive,
//     imageSize: traceEnd.size,
//     imageOffset: new AMap.Pixel(-2, 20)
//   })
//   // offset: new AMap.Pixel(-12, -10)
// })

// export const trace_reach_active = new AMap.Marker({
//   icon: new AMap.Icon({
//     image: wujiaoxing,
//     imageSize: traceReach.size,
//     imageOffset: new AMap.Pixel(-2, 20)
//   })
//   // offset: new AMap.Pixel(-12, -10)
// })

export default {
  marker_car,
  marker_car_red,
  marker_car_active,
  marker_arch,
  marker_arch_active,
  marker_arch_position,
  marker_location,
  marker_location_red,
  marker_location_yellow,
  marker_location_dark_red,
  marker_location_cyan,
  marker_location_orange,
  marker_position,
  marker_position_red,
  marker_position_yellow,
  marker_arrival_point,
  marker_arrival_point_progress,
  marker_arrival_point_start,
  marker_arrival_point_end,
  marker_scene_map,
  marker_trace_asset,
}
